var exports = {
  "U": "x112a1f60--811a0e--arrow",
};

module.exports = exports;
